import React, { memo } from 'react';

const WifiPlanActionBar = ({
  onNew,
  query,
  onQueryChange,
  filterType,
  onFilterTypeChange,
  filterStatus,
  onFilterStatusChange,
}) => (
  <div className="row align-items-center mb-3">
    <div className="col-md-6 d-flex">
      <button className="btn btn-primary mr-2" onClick={onNew}>
        <i className="fa fa-plus mr-1" /> New Plan
      </button>
    </div>

    <div className="col-md-6 d-flex justify-content-md-end mt-2 mt-md-0">
      <input
        className="form-control w-50 mr-2"
        placeholder="Search plans…"
        value={query}
        onChange={(e) => onQueryChange(e.target.value)}
      />
      <select
        className="form-control w-auto mr-2"
        value={filterType}
        onChange={(e) => onFilterTypeChange(e.target.value)}
      >
        <option value="all">All types</option>
        <option value="time">Time</option>
        <option value="data">Data</option>
        <option value="hybrid">Hybrid</option>
      </select>
      <select
        className="form-control w-auto"
        value={filterStatus}
        onChange={(e) => onFilterStatusChange(e.target.value)}
      >
        <option value="all">All statuses</option>
        <option value="active">Active</option>
        <option value="inactive">Inactive</option>
      </select>
    </div>
  </div>
);

export default memo(WifiPlanActionBar);
